import React from 'react';
import { AdfNodeProps } from './AdfModelTypes';
import { AdfNode } from './AdfNode';

export const AdfMediaSingle = React.memo(({ node }: AdfNodeProps) => {
    return <div className="media-single">
        {node.content?.map((x, i) => <AdfNode key={i} node={x} />)}
    </div>;
});
